import { ReactElement } from 'react'
import styled from 'styled-components'
import { Box, Divider, Text, theme } from '@mrshmllw/smores-react'

import SmallMarshallDark from './assets/small-marshall-dark.svg?react'
import SmallMarshallLight from './assets/small-marshall-light.svg?react'
import TrustPilotStarImg from './assets/Trustpilot_ratings_4halfstar-RGB.png'
import TrustpilotLogoDark from './assets/trustpilot-logo-dark.svg'
import TrustpilotLogoLight from './assets/trustpilot-logo-light.svg'
import { SPLIT_PAGE_TABLET_BREAKPOINT } from '../SplitPage'

import { useBreakpoint } from 'utils'

interface TrustpilotReviewBoxProps {
  defaultReview: string | ReactElement
  mobileReview?: string | ReactElement
}

export const TrustpilotReviewBox = ({ defaultReview, mobileReview }: TrustpilotReviewBoxProps) => {
  const deviceType = useBreakpoint(SPLIT_PAGE_TABLET_BREAKPOINT)
  const isMobile = deviceType === 'mobile'
  return (
    <Wrapper>
      <Box px="16px">
        {isMobile ? <SmallMarshallLight /> : <SmallMarshallDark />}
        {isMobile && mobileReview ? (
          <Text mt="16px" typo="heading-small">
            {mobileReview}
          </Text>
        ) : (
          <Text mt="16px" className="large-text">
            {defaultReview}
          </Text>
        )}
      </Box>
      <Divider my="16px" color={isMobile ? 'sesame' : 'chia'} />
      <ClickableTrustpilotWrapper
        href="https://uk.trustpilot.com/review/www.marshmallow.com"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Box px="16px">
          <Box flex alignItems="flex-end">
            <TrustPilotLogo src={isMobile ? TrustpilotLogoDark : TrustpilotLogoLight} />
            <TrustPilotStars src={TrustPilotStarImg} />
          </Box>
          <Box maxWidth="284px">
            <Text mt="8px" typo="headline-small">
              Rated Excellent based on over 20,000 customer reviews
            </Text>
          </Box>
        </Box>
      </ClickableTrustpilotWrapper>
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  background-color: ${theme.colors.feijoa};
  padding: 24px 0;
  border-radius: 16px;
  width: 100%;
  max-width: 416px;
  margin-top: 32px;

  p {
    color: ${theme.colors.coconut};
  }

  @media (min-width: ${SPLIT_PAGE_TABLET_BREAKPOINT}px) {
    background-color: ${theme.colors.coconut};
    margin-top: 0;
    p {
      color: ${theme.colors.liquorice};
    }
    .large-text {
      font-size: 20px;
      line-height: 28px;
    }
  }
`

const TrustPilotStars = styled.img`
  width: 76px;
`
const TrustPilotLogo = styled.img`
  width: 92px;
  margin-right: 8px;
`

const ClickableTrustpilotWrapper = styled.a`
  hover: {
    cursor: pointer;
  }
`
